import styled from "styled-components";

const RedText = styled.span`
  color: ${({ theme }) => theme.colors.secondary_red()};
`;

export default RedText;
